/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';

import { MAIN_COLOR, ButterflyImage } from './ButterflyImage';

const LogoFull = () => {
  return (
    <svg
      width="183"
      height="29"
      viewBox="0 0 183.00492 29.354327"
      version="1.1"
      id="svg5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs id="defs2" />
      <g id="layer1" transform="translate(-17.62545,-46.571581)">
        <g
          id="full-blue-wht"
          transform="matrix(0.26458333,0,0,0.26458333,25.855003,37.635254)"
        >
          <ButterflyImage />
          <text
            style={{
              fontStyle: 'normal',
              fontWeight: 'normal',
              fontSize: '140.939px',
              lineHeight: 1.25,
              fontFamily: 'sans-serif',
              fill: MAIN_COLOR,
              fillOpacity: 1,
              stroke: 'none',
              strokeWidth: 3.52347,
            }}
            x="117.50311"
            y="140.61055"
            id="text1757"
          >
            <tspan
              id="tspan1755"
              x="117.50311"
              y="140.61055"
              style={{ strokeWidth: 3.52347 }}
            >
              Console
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
};

export default LogoFull;
